import { msUntilExpiry } from '@/shared/lib/auth';
import { setUser } from '@/shared/lib/datadog';
import { queryClient } from '@/shared/lib/query-client';
import { tokenManager } from '@/shared/lib/storage';
import { setSessionStorage } from '@/shared/lib/storage/session-storage';
import type { LoginResponse } from '../../authentication/api/generated/model';
import { useSessionStore } from '../model/sessionStore';

/**
 * ログイン処理
 *
 * 責務:
 * - トークンの保存（JWT の exp から正確な有効期限を計算）
 * - セッションストアの更新
 */
export const login = (res: LoginResponse) => {
  // JWT の exp から正確な有効期限を計算
  const ms = msUntilExpiry(res.access);
  const expiresInSeconds = ms ? Math.floor(ms / 1000) : undefined;

  // Datadog にユーザー情報を設定
  setUser(res);

  // トークン保存（Cookie の有効期限を JWT の exp に合わせる）
  tokenManager.setAuthToken(res.access, expiresInSeconds);

  // セッションストアを認証済みに更新（last_loginはログイン前の値なのでここで保存）
  useSessionStore.getState().setUser({
    id: res.id,
    name: res.name,
    email: res.email,
    lastLogin: res.last_login ?? null,
    isFirstLoginCompleted: res.is_first_login_completed,
    role: null, // ログイン時はrole不明。AuthProviderのuseGetCurrentUserで同期される
    tenant: { id: '', code: '', name: '', localGovernmentCode: '' }, // AuthProviderのuseGetCurrentUserで同期される
  });
  useSessionStore.getState().setAuthenticated(true);

  // ログインセッションフラグをセット（ブラウザを閉じると消える）
  // 初回パスワード変更フローでブラウザ再起動時にログインからやり直させるために使用
  setSessionStorage('login-session-active', true);
};

/**
 * ログアウト処理
 *
 * 責務:
 * - トークンのクリア
 * - TanStack Query キャッシュのクリア
 * - セッションストアのクリア
 */
export const logout = () => {
  // トークンクリア
  tokenManager.clearTokens();

  // TanStack Query キャッシュクリア
  queryClient.clear();

  // セッションストアクリア
  useSessionStore.getState().clearSession();
};
